module.exports = __webpack_public_path__ + "static/media/ta-3.ca07f823.jpeg";